module.exports = __webpack_public_path__ + "static/P2101564-4ed87cbfcfa53e67607ff44d9c3edef8.jpg";